<template>
    <div class="completed_content">
        <div class="completed_rabiu">
            <!-- ,objReport.report.state == 1?'wait-title-content':objReport.report.state == 2?'confirm-title-content':'completed_titel' -->
            <div :class="['completed_warp_top confirm-title-content']">
                <div>
                    {{ objReport.report.title }}
                </div>
                <div class="completed_titel_right">
                    <!-- <div class="completed_titel_btn">
                        {{objReport.report.state | setState}}
                    </div> -->
                    <div class="completed_titel_lebel" @click="goBack">
                        <img src="~@/assets/images/pagin/card_up.png" alt="">
                    </div>
                </div>
            </div>
            <div class="completed_warp">
                <div class="completed_warp_text">
                    <div>
                        尊敬的{{ objReport.project.project.name }}：
                    </div>
                    <div class="completed_text">
                        您好，您的{{ objReport.report.title }}已完工。A.O.史密斯品牌监理已依据《冷暖风水系统质量管理标准》，对现场进行监理验收，均已全部合格，敬请确认！
                    </div>
                </div>
                <div class="completed_warp_table">
                    <div :class="['completed_warp_table_item', index % 2 == 0 ? 'completed_warp_backone' : '']"
                        v-for="(item, index) in objReport.report.cate" :key="index">
                        <div class="completed_table_text">{{ item.cate + '质控点' }}</div>
                        <div class="completed_table_num">{{ item.quality_point }}个</div>

                        <div class="completed_table_text_right">验收合格</div>
                        <div class="completed_table_num">{{ item.quality_point }}个</div>
                        <div class="completed_table_icon"></div>
                    </div>
                </div>
                <div class="completed_userinfo" v-if="objReport.project.project_manager.constructor == Object">
                    <div class="userinfo_left">
                        <div class="header_img">
                            <img v-lazy="objReport.project.project_manager.icon" alt="">
                        </div>
                        <div class="ren_user">
                            <div class="ren_user_one" style="white-space: nowrap;">
                                监理：{{ objReport.project.project_supervisor.name }}
                                <span>{{ objReport.project.project_supervisor.job_number }}</span></div>
                            <div class="ren_user_two ren_user_two_on">验收时间：{{ objReport.report.new_actualfinishedon |
                                    filTime
                            }}</div>
                        </div>
                    </div>
                    <div class="userinfo_right">
                        <img src="@/assets/images/pagin/tip_img_unlocking.png" alt="">
                    </div>
                </div>
                <div class="completed_tips">
                    <div class="completed_tips_left">
                        <div>特别</div>
                        <div>提醒</div>
                    </div>
                    <div class="completed_tips_right">
                        <div v-html="objReport.report.remind"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="completed_detail_tips">
            <div class="completed_detail_padding">
                <div class="completed_detail_title">
                    验收详情
                </div>
                <div v-if="objReport.project.project_responsible_person.length">
                    <div class="completed_sm_title">
                        <div>施工人员：</div>
                        <!-- <div class="dateTime">{{item.create_date}}</div> -->
                    </div>
                </div>
                <!-- objReport.project.project_responsible_person.length -->
                <div class="completed_userinfo">
                    <!-- <div class="userinfo_left userinfo-box" v-if="objReport.project.project_salesperson.fullname != ''">
                        <div class="header_img">
                            <img v-lazy="objReport.project.project_salesperson.icon" alt="">
                        </div>
                        <div class="ren_user">
                            <div class="ren_user_three">项目经理：{{objReport.project.project_salesperson.fullname}}</div>
                           <div class="ren_user_two ren_user_two_on">工号：{{objReport.project.project_salesperson.job_number}}</div>
                        </div>
                    </div> -->
                    <div class="userinfo_left userinfo-box"
                        v-for="(item, index) in objReport.project.project_responsible_person_list" :key="index">
                        <div class="header_img">
                            <img v-lazy="item.icon" alt="">
                        </div>
                        <div class="ren_user">
                            <div class="ren_user_three">{{ item.rel_group_name }}：{{ item.name }}</div>
                            <div class="ren_user_two ren_user_two_on">工号：{{ item.job_number }}</div>
                        </div>
                    </div>
                </div>
                <div class="completed_sm_title">
                    <div>验收清单</div>
                </div>
                <div class="completed_btn_padding">
                    <!-- <div :class="['completed_btn',index == nTopBtnIndex ?'completed_btn_back':'']" v-for="(item,index) in arrTopBtn" @click="nTopBtnIndex = index" :key="index">
                        {{item.name}}
                    </div> -->
                    <div class="completed_btn_sm">
                        <div :class="['completed_sm_btn', index == nSmBtnIndex ? 'completed_sm_btn_back' : '']"
                            v-for="(item, index) in arrCate" @click="getSmBtnIndex(index)" :key="index">
                            {{ item.cate }}质控点{{ item.quality_point }}个</div>
                    </div>
                </div>
                <div class="completed_btn_sm_biaoqian" v-if="arrCate[nSmBtnIndex].tag.length">
                    <div class="completed_btn_bg">
                        <div :class="['completed_btn', index == nTopBtnIndex ? 'completed_btn_back' : '']"
                            v-for="(item, index) in arrCate[nSmBtnIndex].tag" @click="nTopBtnIndex = index" :key="index">
                            {{ item.name }}
                        </div>
                    </div>
                </div>
                <!-- <div class="install_title">风机盘管安装</div> -->
            </div>
            <!-- 有施工小类 -->
            <!-- <div class="swiper_img" v-if="arrCate[nSmBtnIndex].tag.length&&arrCate[nSmBtnIndex].tag[nTopBtnIndex].standard_photo_url">
                <van-swipe class="swiper_img" indicator-color="white" :show-indicators="false" ref="vanswipe">
                    <van-swipe-item v-for="(item,index) in arrCate[nSmBtnIndex].tag[nTopBtnIndex].standard_photo_list" :key="index">
                        <div class="swipe_img_url" @click="getShow(arrCate[nSmBtnIndex].tag[nTopBtnIndex].standard_photo_url)">
                            <img v-lazy="item" alt="">
                            <div class="swipe_img_label_green">施工标准</div>
                        </div>
                    </van-swipe-item>
                </van-swipe>
                 <div class="left_swiper" @click="prev('vanswipe')" v-if="arrCate[nSmBtnIndex].tag[nTopBtnIndex].standard_photo_list.length > 1">
                    <img src="@/assets/images/pagin/left_swiper.png" alt="">
                </div>
                <div class="right_swiper" @click="next('vanswipe')" v-if="arrCate[nSmBtnIndex].tag[nTopBtnIndex].standard_photo_list.length > 1">
                    <img src="@/assets/images/pagin/right_swiper.png" alt="">
                </div>
            </div> -->
            <!-- 没有施工小类 -->
            <!-- <div class="swiper_img" v-if="!arrCate[nSmBtnIndex].tag.length&&arrCate[nSmBtnIndex].standard_photo_url">
                <van-swipe class="swiper_img" indicator-color="white" :show-indicators="false" ref="vanswipe">
                    <van-swipe-item>
                        <div class="swipe_img_url" @click="getShow(arrCate[nSmBtnIndex].standard_photo_url)">
                            <img v-lazy="arrCate[nSmBtnIndex].standard_photo_url" alt="">
                            <div class="swipe_img_label_green">施工标准</div>
                        </div>
                    </van-swipe-item>
                </van-swipe>
                <div class="left_swiper" @click="prev('vanswipe')">
                    <img src="@/assets/images/pagin/left_swiper.png" alt="">
                </div>
                <div class="right_swiper" @click="next('vanswipe')">
                    <img src="@/assets/images/pagin/right_swiper.png" alt="">
                </div>
            </div> -->
            <!-- 有施工小类下面的图片 -->
            <div class="swiper_img"
                v-if="arrCate[nSmBtnIndex].tag.length && arrCate[nSmBtnIndex].tag[nTopBtnIndex].arrAttach.length">
                <van-swipe class="swiper_img" :show-indicators="false" ref="vanswipetwo" :loop="false"
                    @change="swipetwo">
                    <van-swipe-item v-for="(item, index) in arrCate[nSmBtnIndex].tag[nTopBtnIndex].arrAttach"
                        :key="index">
                        <div class="swipe_img_url" @click="getShow(item.image_url)">
                            <img v-lazy="item.image_url" alt="">
                            <div class="swipe_img_label">工地实况</div>
                        </div>
                    </van-swipe-item>
                </van-swipe>
                <div class="left_swiper" @click="prev('vanswipetwo')"
                    v-if="arrCate[nSmBtnIndex].tag[nTopBtnIndex].arrAttach.length > 1">
                    <img src="@/assets/images/pagin/left_swiper.png" alt="">
                </div>
                <div class="right_swiper" @click="next('vanswipetwo')"
                    v-if="arrCate[nSmBtnIndex].tag[nTopBtnIndex].arrAttach.length > 1">
                    <img src="@/assets/images/pagin/right_swiper.png" alt="">
                </div>
            </div>
            <!-- 没有施工小类下面的图片 -->
            <div class="swiper_img" v-if="!arrCate[nSmBtnIndex].tag.length && arrCate[nSmBtnIndex].arrAttach.length">
                <van-swipe class="swiper_img" :show-indicators="false" ref="vanswipetwo" :loop="false"
                    @change="swipetwo">
                    <van-swipe-item v-for="(item, index) in arrCate[nSmBtnIndex].arrAttach" :key="index">
                        <div class="swipe_img_url" @click="getShow(item.image_url)">
                            <img v-lazy="item.image_url" alt="">
                            <div class="swipe_img_label">工地实况</div>
                        </div>
                    </van-swipe-item>
                </van-swipe>
                <div class="left_swiper" @click="prev('vanswipetwo')">
                    <img src="@/assets/images/pagin/left_swiper.png" alt="">
                </div>
                <div class="right_swiper" @click="next('vanswipetwo')">
                    <img src="@/assets/images/pagin/right_swiper.png" alt="">
                </div>
            </div>
            <div class="swiper_img_list">
                <div class="swiper_item_warp"
                    v-if="arrCate[nSmBtnIndex].tag.length && arrCate[nSmBtnIndex].tag[nTopBtnIndex].arrAttach.length"
                    :style="{ 'transform': 'translateX(' + nTranslateX + 'px)' }">
                    <div class="swiper_item_url"
                        v-for="(item, index) in arrCate[nSmBtnIndex].tag[nTopBtnIndex].arrAttach" :key="index"
                        @click="swipeToUrl('vanswipetwo', index)">
                        <div :class="[nSwiperIndex == index ? 'swiper_bg_url' : 'swiper_sm_url']">
                            <img :src="item.image_url" alt="">
                        </div>
                    </div>
                </div>
                <!-- <van-swipe class="swiper_item_warp" ref="vanswipetwo" :width="100">
                    <van-swipe-item v-for="item in 4" :key="item">
                        <div class="swipe_img_url" @click="getShow(require('@/assets/images/pagin/swiper_one.png'))">
                            <img src="@/assets/images/pagin/swiper_one.png" alt="">
                        </div>
                    </van-swipe-item>
                </van-swipe> -->
            </div>
            <div class="point_content">
                <div class="point_table">
                    <div class="point_table_one">验收质控点</div>
                    <div class="point_table_two">施工标准</div>
                    <div class="point_table_three">验收结果</div>
                </div>
                <div class="point_table_on">
                    <!-- objReport.report.cate[nSmBtnIndex].control -->
                    <div class="point_table_item" v-for="(item, index) in objControl" :key="index">
                        <div class="point_table_top">
                            <div class="point_table_one">
                                <div style="width:180px" v-html="item.title"></div>

                            </div>
                            <div class="point_table_two">{{ item.standard_answer }}</div>
                            <div class="point_table_three" :style="{ 'color': item.color }">{{ item.answer_result }}</div>
                        </div>
                        <div class="point_table_help">
                            {{ item.selling_points }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="evaluate" v-if="objReport.report.report_appraise.constructor == Object && is_completed == 0">
            <div class="evaluate_tips">我的评价</div>
            <div class="eva-context-info">
                <div class="title">
                    <p>客户星级评价</p>
                    <div>
                        <img :src="require('@/assets/images/user/house/completion-star-icon.png')"
                            v-for="item in Number(objReport.report.report_appraise.score)" :key="item" alt="">
                    </div>

                </div>
                <div class="tags">
                    <div class="tags_item" v-for="(tags, tagNum) in objReport.report.report_appraise.tag_name"
                        :key="tagNum">{{ tags.name }}</div>
                </div>
                <p class="eva-text">{{ objReport.report.report_appraise.desc }}</p>
            </div>
        </div>
        <div class="bottom_btn" v-if="is_completed == 0">
            <div class="left_btn">
                有疑问
                <a :href="'tel:' + objReport.project.project_manager.phone"></a>
            </div>
            <div class="right_btn" @click="changeConfirmPopupVisible"
                v-if="objReport.report.report_appraise.constructor == Array">
                我要评价
            </div>
        </div>

        <div class="content-wrap" v-if="is_completed == 1">
            <div class="card sub-card">
                <div class="title">我的评价</div>
                <p class="finish-con">
                    <!-- {{ "非常感谢您对A.O.史密斯的信任和支持，您的" + processName + "已经全部安装并调试完毕，现场验收合格还请您验收。"}}。 -->
                    非常感谢您对A.O.史密斯的信任和支持，您的冷暖风水系统产品已经全部安装并调试完毕，监理已依据《冷暖风水系统质量管理标准》，对现场进行监理验收，
                    均已全部合格，还请您验收！
                </p>
                <div class="finish-btn-wrap flc">
                    <img class="finish-btn" :src="isAgree ? checkSelect : checkCommon"
                        @click="!isAgree ? isAgree = !isAgree : ''" />
                    <div class="finish-btn-text">我已阅并确认验收合格</div>
                </div>
            </div>
            <div class="card">
                <div class="card-title fls">
                    <div class="card-title-block"></div>
                    <p class="card-title-text">{{ "对本" + processName + "是否满意?" }}</p>
                </div>
                <!--评星-->
                <div class="star-wrap">
                    <div class="star-item fls" v-for="(item, index) in evaStarList" :key="index">
                        <div class="star-item-text">{{ item.title }}</div>
                        <div class="star-item-img flc">
                            <img v-for="(star, index2) in item.star" :key="index2" :src="star ? starSelect : starCommon"
                                class="star" alt="" @click="lightStar(index, index2)" />
                        </div>
                    </div>
                </div>
                <textarea class="advice-text" v-model="sContent" v-if="currentType == 1" name="" id="" cols="30"
                    rows="10" placeholder="您好，分享您的销售体验、施工体验等给我们更多建议，以便为您更好的服务。"></textarea>
                <div class="content" v-else>{{ content }}</div>
                <!-- <div class="recording-btn flc" @click="clickRecord" v-if="currentType == 1">
                    <img src="@/assets/images/user/house/record-icon.png" alt=""> -->
                <!-- <div>点击录制评价语音</div> -->
                <!--  <div>{{status == 'start' ? '点击结束录制':'点击录制评价语音'}}</div>
                </div>
                <div class="recording-btn flc" style="margin-top:20px;" @click.stop="audioClick" v-else>
                    <audio ref="audioRef" class="audio-ref" :src="sAudioUrl" />
                    <img src="@/assets/images/user/house/record-icon.png" alt="">
                    <div>查看语音评价</div>
                </div>  -->
                <div class="addContent" v-if="currentType == 3">
                    <div>追加评价</div>
                    <div>{{ addContent }}</div>
                    <div class="imgbox">
                        <div class="img-div" v-for="(item, index) in arrLocalBase64" :key="index">
                            <img v-if="item.type == 'image'" @click="handleImagePreview(arrLocalBase64, index)"
                                :src="item.pic" alt="" class="img">
                            <video v-else :src="item.pic" @click="playVideo(item.pic)" class="img"></video>
                        </div>
                    </div>
                </div>
                <div class="addContent2" v-if="currentType == 2">
                    <div>追加评价</div>
                    <input class="input" type="text" v-model="addContent" placeholder='这里输入追加评价'>
                    <div class="imgbox">
                        <div class="img-div" v-for="(item, index) in arrMedia" :key="index">
                            <img @click="deleImg(index)" class="delete-image" src="@/assets/images/image-delete.png" />
                            <img v-if="item.type == 'image'" @click="handleImagePreview(arrMedia, index)" :src="item.url"
                                alt="" class="img">
                            <video v-else @click="playVideo(item.url)" :src="item.url" alt="" class="img"></video>

                            <!-- <div v-if="isVideoShow" style="width:100%"> -->

                            <!-- 弹出层 -->
                            <!-- <van-overlay :show="isVideoShow" show-cancel-button width="100%" @click="isVideoShow = false">
                                <div class="wrapper">
                                    <video :src="item.url" controls></video>
                                </div>
                            </van-overlay> -->
                            <!-- </div> -->
                        </div>
                        <div class="img-div">
                            <img v-show="this.nMediaCount > this.arrMedia.length" @click="choiceImg"
                                src="@/assets/images/user/house/save1.png" alt="" class="img">
                        </div>
                        <input @change="imageToBase64" v-show="false" ref="filElem" type="file" id="input" />
                        <div id="in-box" style="display:none"></div>
                    </div>
                    <div @click="reSubmit" class="addContentBtn">
                        追加评价
                    </div>
                </div>
            </div>
            <!--提交按钮-->
            <div class="bottom_btn" v-if="is_completed == 1">
                <div class="left_btn">
                    有疑问
                    <a :href="'tel:' + objReport.project.project_manager.phone"></a>
                </div>
                <div class="right_btn" @click="submit" v-if="currentType == 1">
                    确认验收
                </div>
            </div>
            <!--    <van-popup v-model="BshowToast" custom-style="padding:10px;" @close='handleClose'>
                <div style="padding:10px;">
                    <div style="font-weight: 800;">提示</div>
                    <div style="margin-top:10px;">已结束录制，您可选择重新录制与试听录音</div>
                    <div style="margin-top:10px;text-align: center;">
                        <van-button size="small" square type="primary" @click="recordAgin">重新录制</van-button>
                        <van-button style="margin-left: 10px;" size="small" square type="primary" @click="Audition">{{AuditionStatus}}</van-button>
                    </div>
                </div>

            </van-popup>
            <van-popup class="pop" v-model="isVideoShow" closeable position="bottom" :style="{ height: '100%'  }">
                <div class="wrapper" v-if="isVideoShow">
                    <video :src="sVideoPath" controls></video>
                </div>
            </van-popup>  -->
        </div>
        <!--     确认验收弹窗      -->
        <Popup v-model="bConfirmPopupVisible" class="confirm-cover-popup">
            <!--            标题      -->
            <p class="title">{{ `对本次的${objReport.report.title}验收是否满意` }}</p>
            <!-- <p class="star-text">{{ '非常满意，无可挑剔' }}</p> -->
            <startEvaluate @scoreChange="scoreChange"></startEvaluate>
            <!--     标签       -->
            <div class="tags-content">
                <div @click="changeTagActive(tag.id)" v-for="(tag, tagIndex) in arrAcceptance" :key="tagIndex"
                    class="tags-item" :class="{ 'tags-item-active': arrAcceptanceActive.includes(tag.id) }">
                    <p>{{ tag.name }}</p>
                </div>
            </div>
            <!--    文本输入控件       -->
            <textarea class="text-input" placeholder="其他想说的：" v-model="tagsText" />
            <!--        提交按钮    -->
            <div class="commit-button" @click="getMemberAppraise">提交评价</div>
        </Popup>
        <!-- 预览图片 -->
        <van-image-preview v-model="pdfShow" :closeable="true" :startPosition="lookImgIndex" :images="arrPdfImg"
            @change="lookChang">
            <template v-slot:imgIndex>第{{ imgIndex }}页</template>
        </van-image-preview>
        <!-- 勾选弹窗 -->
        <div class="tips_read" v-if="bTipsRead" @click.stop="bTipsRead = !bTipsRead">
            <div class="tips_read_content">
                <div>请勾选已阅并确认验收合格</div>
                <div class="text_read">如疑问，请点击“有疑问”联系项目经理，谢谢</div>
                <div class="read_btn" @click.stop="bTipsRead = !bTipsRead, isAgree = true">确认</div>
            </div>
        </div>
    </div>
</template>

<script>
import oDeliver from "@/js/deliver.js";
import { Popup, Picker, ImagePreview } from "vant";
import startEvaluate from "@/page/service/components/startevaluate";
import { getWxSingleConfig } from "@/js/wx.js";
import { sendSeriveId } from "@/js/finish.js";
import { getUserIndex } from "@/js/house/index.js";
import net from "@/js/evaluate";
let OSS = require("ali-oss");
export default {
    components: {
        Popup,
        VantPicker: Picker,
        startEvaluate,
    },
    data() {
        return {
            bTipsRead: false,
            arrCate: [{ arrAttach: [], arrConstruction: [], tag: [{ construction: [], arrAttach: [] }] }], //验收图片以及详情
            // 验收项激活
            arrAcceptanceActive: [],
            // 确认验收弹窗显示
            bConfirmPopupVisible: false,
            // 验收服务项
            arrAcceptance: [],
            // tag评分星星
            nUserScore: 5,
            // 评分文字
            tagsText: "",
            pdfShow: false, //查看图片
            starCommon: require("@/assets/images/user/house/star-common.png"),
            starSelect: require("@/assets/images/user/house/star-select.png"),
            evaStarList: [],
            lookImgIndex: 0,
            imgIndex: 0,
            arrPdfImg: [],
            nTopBtnIndex: 0,
            nSmBtnIndex: 0,
            objReport: {
                project: {
                    project_responsible_person: {},
                    project_supervisor: {},
                    project_salesperson: { fullname: '' },
                    project: {
                        name: "",
                    },
                    project_manager: {
                        constructor: "",
                        phone: '',
                    },
                },
                report: {
                    cate: [{ tag: [], control: [] }],
                    title: "",
                    report_appraise: {
                        score: 0,
                    },
                },
            }, //交付详情
            arrTopBtn: [
                { name: "风盘定位" },
                { name: "水力模块定位" },
                { name: "其它模块" },
                { name: "风盘定位" },
                { name: "水力模块定位" },
                { name: "其它模块" },
            ],
            arrTag: ["及时预约", "服务专业", "设计严谨"],
            nSwiperIndex: 0, //轮播图索引

            construction: [],
            demonstration: [],

            is_completed: 0,
            isVideoShow: false, //是否显显示视频播放控件
            oss: {}, //oss相关配置
            upLoadFiles: [], //传给后台的数据
            arrMedia: [], //本地展示的数据
            nMediaCount: 6, //上传的多媒体数量限制
            addContent: "", //追加评价
            topPic: "",
            processName: "",
            content: "",
            company_id: "", //公司id
            contract_id: "", //合同id
            topic_id: this.$route.query.topic_id, //项目id
            sProjectUuid: "",
            isAgree: false,
            checkCommon: require("@/assets/images/user/house/check-common.png"),
            checkSelect: require("@/assets/images/user/house/check-select.png"),
            starCommon: require("@/assets/images/user/house/star-common.png"),
            starSelect: require("@/assets/images/user/house/star-select.png"),
            evaStarList: [
                {
                    title: "销售体验满意度",
                    star: [false, false, false, false, false],
                },
                {
                    title: "系统设计满意度",
                    star: [false, false, false, false, false],
                },
                {
                    title: "安装人员满意度",
                    star: [false, false, false, false, false],
                },
                {
                    title: "系统施工满意度",
                    star: [false, false, false, false, false],
                },
                {
                    title: "服务效率满意度",
                    star: [false, false, false, false, false],
                },
            ],
            status: "close",
            localId: "",
            BshowToast: false,
            AuditionStatus: "试听录音", //控制试听的播放和暂停
            currentType: 1,
            voiceData: "",
            sVoiceUrl: "",
            sContent: "",
            sVideoPath: "",
            sAudioUrl: "",
        };
    },
    created() {
        document.title = this.$route.query.type ? '竣工验收' : '监理报告';
        let _that = this;
        $init(() => {
            _that.getMeberInfo();
            _that.getMemberTag();
            this.$store.dispatch("banner/getData", 12);
            getWxSingleConfig();
            _that.getId();
        });
    },
    filters: {
        setState(e) {
            switch (e) {
                case 1:
                    return "待确认";
                    break;
                case 2:
                    return "已确认";
                    break;
                case 3:
                    return "待交付";
                    break;
            }
        },
        filTime(val) {
            if (val != '') {
                val = val.replace(/\-/g, '/');
                let getValTime = new Date(val);
                let y = getValTime.getFullYear();
                let m = getValTime.getMonth() + 1;
                let d = getValTime.getDate();
                return y + '.' + m + '.' + d
            } else {
                return ''

            }
        }
    },
    computed: {
        // 质控点描述
        objControl() {
            let _that = this;
            if (_that.objReport.report.cate[_that.nSmBtnIndex].control.length) {
                let arrControl =
                    _that.objReport.report.cate[_that.nSmBtnIndex].control;
                if (_that.objReport.report.cate[_that.nSmBtnIndex].tag.length) {
                    let tagId =
                        _that.objReport.report.cate[_that.nSmBtnIndex].tag[
                            _that.nTopBtnIndex
                        ].tag_id;
                    let arr = arrControl.filter((it) => {
                        return it.tag_id == tagId;
                    });
                    return arr;
                } else {
                    return arrControl;
                }
            }
        },
        arrCateImg: function () {
            let _that = this;
            this.nSwiperIndex = 0;
            if (_that.objReport.report.cate[_that.nSmBtnIndex].control.length) {
                let arrControl =
                    _that.objReport.report.cate[_that.nSmBtnIndex].control;
                if (_that.objReport.report.cate[_that.nSmBtnIndex].tag.length) {
                    if (
                        _that.nTopBtnIndex + 1 >
                        _that.objReport.report.cate[_that.nSmBtnIndex].tag
                            .length
                    ) {
                        _that.nTopBtnIndex = 0;
                    }
                    let tagId =
                        _that.objReport.report.cate[_that.nSmBtnIndex].tag[
                            _that.nTopBtnIndex
                        ].tag_id;
                    let arr = [];
                    arrControl.forEach((it) => {
                        if (it.tag_id == tagId) {
                            arr = arr.concat(it.attach);
                        }
                    });
                    return arr;
                } else {
                    let arr = [];
                    arrControl.forEach((it) => {
                        arr = arr.concat(it.attach);
                    });
                    return arr;
                }
            }
        },
        nTranslateX: function () {
            if (this.arrCateImg != undefined) {
                if (
                    this.arrCateImg &&
                    this.nSwiperIndex < this.arrCateImg.length - 2
                ) {
                    if (this.nSwiperIndex > 0) {
                        return 89 * (this.nSwiperIndex - 1) * -1;
                    } else if (this.nSwiperIndex == 0) {
                        return 0;
                    }
                }
            }
        },
    },
    methods: {
        // 轮播图滑动
        swipetwo(e) {
            this.nSwiperIndex = e;
        },
        // 选择验收清单标签
        getSmBtnIndex(num) {
            this.nSmBtnIndex = num;
            this.nTopBtnIndex = 0;
        },
        /**
         * 改变验收弹窗显示
         */
        changeConfirmPopupVisible() {
            let id = this.$route.query.id;
            if (id != 4) {
                this.bConfirmPopupVisible = !this.bConfirmPopupVisible;
                this.arrAcceptanceActive = [];
            } else {
                const { project } = this.objReport.project;
                window.location.href = `${window.location.origin}/user/house/finish?company_id=${project.new_contractid}&project_uuid=${project.new_srv_projectmgnid}&contract_id=${project.new_contractid}&processName=${project.new_name}`;
                // this.$router.push({ path: "/user/house/finish" });
            }
        },
        /**
         * 改变验收激活项员素
         * @param {string} tag
         */
        changeTagActive(tag) {
            this.arrAcceptanceActive.includes(tag)
                ? (this.arrAcceptanceActive = this.arrAcceptanceActive.filter(
                    (i) => i !== tag
                ))
                : this.arrAcceptanceActive.push(tag);
        },
        // 提交评价
        getMemberAppraise() {
            let _that = this;
            if (_that.nUserScore <= 3 && _that.tagsText == "") {
                _that.$toast({
                    message: "请填写评语",
                    duration: 1000,
                });
                return false;
            }
            _that.$store.commit("loadSwitch", true);
            let objData = {
                report_id: _that.$route.query.id,
                score: _that.nUserScore,
                desc: _that.tagsText,
                tag_id: _that.arrAcceptanceActive.join(","),
            };
            oDeliver.getMemberAppraise(objData).then((res) => {
                _that.$toast({
                    message: "提交成功",
                    duration: 1000,
                });
                _that.$store.commit("loadSwitch", false);
                _that.bConfirmPopupVisible = false;
                _that.getMeberInfo();
            });
        },
        // 获取星星评价
        scoreChange(e) {
            this.nUserScore = e;
            this.getMemberTag();
        },
        // 评价tag
        getMemberTag() {
            let _that = this;
            oDeliver.getMemberTag({ rank: _that.nUserScore }).then((res) => {
                _that.arrAcceptance = res.result;
            });
        },
        // 交付详情
        getMeberInfo() {
            let _that = this;
            _that.$store.commit("loadSwitch", true);
            oDeliver
                .getMeberInfo({ report_id: _that.$route.query.id })
                .then((res) => {
                    _that.$store.commit("loadSwitch", false);
                    _that.objReport = res.result;
                    _that.is_completed = res.result.report.is_completed;
                    if (_that.is_completed == 0) {
                        document.title = '监理验收报告'
                    } else if (_that.is_completed == 1) {
                        document.title = '竣工验收'
                    }
                    console.log(document.title)
                    res.result.report.cate.forEach((a) => {
                        if (a.tag.length) {
                            a.tag.forEach((i) => {
                                i.arrAttach = [];
                                i.construction = [];
                                i.arrControl = a.control.filter((f) => {
                                    if (f.tag_id == i.tag_id) {
                                        i.arrAttach = i.arrAttach.concat(f.attach);
                                    }
                                    return f.tag_id == i.tag_id;
                                });
                                i.construction = a.control.filter((c) => {
                                    return c.standard_photo_url != "";
                                });
                            });
                        } else {
                            a.arrAttach = [];
                            a.control.forEach((f) => {
                                a.arrAttach = a.arrAttach.concat(f.attach);
                            });
                            a.arrConstruction = [];
                            a.arrConstruction = a.control.filter((c) => {
                                return c.standard_photo_url != "";
                            });
                        }
                    });
                    _that.arrCate = res.result.report.cate;
                    console.log(res.result.report.cate);
                });
        },
        getShow(e) {
            this.pdfShow = true;
            this.arrPdfImg = [e];
        },
        lookChang(e) { },
        // 返回上一页
        goBack() {
            this.$router.go(-1); //返回上一层
        },
        prev(type) {
            let _that = this;
            _that.$refs[type].prev();
        },
        next(type) {
            let _that = this;
            _that.$refs[type].next();
        },
        swipeToUrl(type, index) {
            let _that = this;
            _that.$refs[type].swipeTo(index);
        },
        deleImg(index) {
            this.arrMedia.splice(index, 1);
            this.upLoadFiles.splice(index, 1);
        },

        imageToBase64() {
            var _this = this;
            const inputFile = this.$refs.filElem.files[0];
            this.$refs.filElem.value = null;

            this.inputFile = inputFile;
            console.log(this.inputFile);
            if (this.inputFile) {
                let inputFile = this.inputFile;
                if (
                    inputFile.type !== "image/jpeg" &&
                    inputFile.type !== "image/png" &&
                    inputFile.type !== "image/jpg" &&
                    inputFile.type !== "video/mp4"
                ) {
                    alert("上传图片或者视频！", "warning");
                    return;
                }
                if (inputFile.size > 50 * 1024 * 1024) {
                    alert("请上传小于 50M 的图片 ！", "warning");
                    return;
                }
                this.uploadImg(inputFile);
            } else {
                return;
            }
        },
        uploadImg(inputFile) {
            var data = inputFile.name;

            let flieArr = data.split(".");
            let suffix = flieArr[flieArr.length - 1];
            let uploadData = {
                ext: suffix,
            };
            // 获取oss配置
            net.ossconfig(uploadData).then((res) => {
                let uploadOss = res.data.data.result;
                let client = new OSS({
                    region: uploadOss.sts.region,
                    bucket: uploadOss.sts.bucket,
                    accessKeyId: uploadOss.sts.access_key_id,
                    accessKeySecret: uploadOss.sts.access_key_secret,
                    endpoint: uploadOss.sts.endpoint_internal,
                    stsToken: uploadOss.sts.security_token,
                    secure: true,
                });

                // oss 上传
                client
                    .multipartUpload(uploadOss.object_name, inputFile)
                    .then((res) => {
                        this.upLoadFiles.push({
                            type: inputFile.type.split("/")[0],
                            url: uploadOss.filename,
                            default: uploadOss.default,
                        });
                        this.arrMedia.push({
                            type: inputFile.type.split("/")[0],
                            url: uploadOss.url,
                            default: uploadOss.default,
                        });
                        console.log(this.arrMedia);
                    });
            });
        },

        choiceImg() {
            this.$refs.filElem.dispatchEvent(new MouseEvent("click"));
        },
        // 关闭弹窗触发的函数
        handleClose() {
            this.stopListen();
        },
        // 判断用户目前是否在试听录音
        stopListen() {
            if (this.AuditionStatus == "正在试听") {
                wx.stopVoice({
                    localId: this.localId, // 需要停止的音频的本地ID，由stopRecord接口获得
                });
            }
            this.BshowToast = false;
            this.AuditionStatus = "试听录音";
        },
        // 点击重新录制触发的函数
        recordAgin() {
            this.stopListen();
            this.clickRecord();
        },
        // 点击试听触发的函数
        Audition() {
            if (this.AuditionStatus != "正在试听") {
                this.AuditionStatus = "正在试听";
                wx.playVoice({
                    localId: this.localId, // 需要播放的音频的本地ID，由stopRecord接口获得
                });
            } else {
                this.AuditionStatus = "已暂停";
                wx.pauseVoice({
                    localId: this.localId, // 需要暂停的音频的本地ID，由stopRecord接口获得
                });
            }
        },
        // 上传已录制语音
        updateVoice() {
            wx.uploadVoice({
                localId: this.localId, // 需要上传的音频的本地ID，由stopRecord接口获得
                isShowProgressTips: 1, // 默认为1，显示进度提示
                //可以在success回调里把id传给自己的服务器后台，然后走微信服务器里下载
                success: (result) => {
                    // serverId = res.serverId; // 返回音频的服务器端ID
                    // alert('上传成功')
                    // alert(result.serverId);

                    //把录音在微信服务器上的id（res.serverId）发送到自己的服务器供下载。
                    // Sendserive_id({service_id:result.serverId}).then(result2 => {console.log(result2,'这个是结果2');})
                    // this.$store.dispatch("finish/SendId", {
                    //     service_id: result.serverId,
                    // });

                    sendSeriveId({ service_id: result.serverId }).then(
                        (res) => {
                            console.log(res);
                            let result = res.result;
                            this.sVoiceUrl = result.local_file;
                            console.log(this.sVoiceUrl);
                            this.discussAdd(this.sVoiceUrl);
                        }
                    );
                },
            });
        },
        // 点亮星星
        lightStar(i, i2) {
            // 先全置否再重新赋值
            if (this.currentType == 1) {
                for (let j = 0; j < 5; j++) {
                    if (j <= i2) {
                        this.evaStarList[i].star[j] = true;
                    } else {
                        this.evaStarList[i].star[j] = false;
                    }
                }
                this.$forceUpdate();
            }
        },
        /**
         * 点击录音
         */
        clickRecord() {
            if (this.status === "close") {
                this.status = "start";
                wx.startRecord({
                    success: () => {
                        //alert("录音中");
                    },
                    cancel: () => {
                        //alert("不允许");
                    },
                    fail: (res) => {
                        alert(JSON.stringify(res));
                    },
                });
            } else if (this.status === "start") {
                this.status = "close";
                wx.stopRecord({
                    success: (res) => {
                        this.localId = res.localId;
                        this.BshowToast = true;
                        console.log(res);
                    },
                    fail: (res) => {
                        alert(JSON.stringify(res));
                    },
                });
            }
        },
        //根据数字转换成数组
        getStar(val) {
            let star = [];
            for (let i = 0; i < 5; i++) {
                if (i < val) {
                    star.push(true);
                } else {
                    star.push(false);
                }
            }
            return star;
        },
        //找出数组ture数量转换成数字
        getRank(arr) {
            let count = 0;
            arr.forEach((item) => {
                if (item == true) count++;
            });

            return count;
        },
        submit() {
            if (!this.isAgree) {
                this.bTipsRead = !this.bTipsRead;
                return;
            }
            // 上传语音录入的方法
            if (this.localId) {
                this.updateVoice();
            } else {
                this.discussAdd("");
            }
        },
        discussAdd(val) {
            let data = {
                type: 1,
                content: this.sContent,
                contract_id: this.contract_id,
                project_uuid: this.sProjectUuid,
                company_id: this.company_id ? this.company_id : 1,
                voice: val,
            };
            this.evaStarList.forEach((item, index) => {
                switch (index) {
                    case 0:
                        data.sale_score = this.getRank(item.star);
                        break;
                    case 1:
                        data.sign_score = this.getRank(item.star);
                        break;
                    case 2:
                        data.work_score = this.getRank(item.star);
                        break;
                    case 3:
                        data.delivery_score = this.getRank(item.star);
                        break;
                    case 4:
                        data.service_score = this.getRank(item.star);
                        break;
                }
            });
            net.discussAdd(data).then((res) => {
                this.$router.go(-1);
            });
        },
        //添加追加评价
        reSubmit() {
            //if (this.topic_id && this.company_id && this.contract_id) {
            let data = {
                content: this.addContent,
                pic: JSON.stringify(this.upLoadFiles), //oss返回的图片或视频链接
                contract_id: this.contract_id,
                company_id: this.company_id ? this.company_id : 1,
                //topic_id: this.topic_id,
                project_uuid: this.sProjectUuid,
            };
            net.reSubmit(data).then((res) => {
                this.$toast("添加成功");
                this.$router.go(-1);
            });
        },
        playVideo(url) {
            this.isVideoShow = true;
            this.sVideoPath = url;
        },
        handleImagePreview(arrList, index) {
            if (arrList[index].type === "image") {
                let arrImage = [];
                //let data = JSON.parse(JSON.stringify(arrList))
                arrList.forEach((item) => {
                    //过滤video
                    if (item.type === "image") {
                        if (item.pic) {
                            arrImage.push(item.pic);
                        } else if (item.url) {
                            arrImage.push(item.url);
                        }
                    }
                });
                let str = "";
                if (arrList[index].pic) {
                    str = arrList[index].pic;
                } else if (arrList[index].url) {
                    str = arrList[index].url;
                }
                //arrImage.splice(index, 1)
                //arrImage.splice(0, 0, str)
                ImagePreview(arrImage, index);
            }
        },
        audioClick() {
            const audio = this.$refs.audioRef;
            audio.paused ? audio.play() : audio.pause();
            // if (audio.paused) {
            //     // console.log("语音动态关");
            //     this.isAudio = false
            // } else {
            //     // console.log("语音动态开");
            //     this.isAudio = true
            // }
        },
        getId() {
            getUserIndex().then((res) => {
                // console.log(res);debugger
                this.company_id = res.data.data.result.project.new_id;
                this.sProjectUuid =
                    res.data.data.result.project.new_srv_projectmgnid;
                this.contract_id = res.data.data.result.contract.new_contractid;
                this.processName = res.data.data.result.project.new_name;

                net.getList({ project_uuid: this.sProjectUuid }).then((res) => {
                    if (res.data.data.result.completed.length == 0) {
                        this.currentType = 1;
                    } else if (res.data.data.result.completedTo.length == 0) {
                        this.isAgree = true;
                        this.currentType = 2;
                    } else {
                        this.isAgree = true;
                        this.currentType = 3;
                    }
                    //console.log(this.currentType)
                    var object = res.data.data.result.completed;
                    this.sAudioUrl = object.voice;
                    this.content = object.content;
                    this.arrLocalBase64 = res.data.data.result.completedTo.pic;
                    this.addContent = res.data.data.result.completedTo.content;
                    this.evaStarList.forEach((item, index) => {
                        switch (index) {
                            case 0:
                                item.star = this.getStar(object.sale_score);
                                break;
                            case 1:
                                item.star = this.getStar(object.sign_score);
                                break;
                            case 2:
                                item.star = this.getStar(object.work_score);
                                break;
                            case 3:
                                item.star = this.getStar(object.delivery_score);
                                break;
                            case 4:
                                item.star = this.getStar(object.service_score);
                                break;
                        }
                    });
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.tips_read {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    background: rgba(0, 0, 0, 0.747);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: identifier 0.8s forwards;

    .tips_read_content {
        width: 600px;
        background: #fff;
        padding: 20px 40px;
        box-sizing: border-box;
        font-size: 34px;
        text-align: justify;
        border-radius: 10px;

        .text_read {
            padding: 20px 0;
            box-sizing: border-box;
            border-bottom: 1px solid rgb(148, 204, 250);
        }

        .read_btn {
            width: 100px;
            height: 60px;
            background: $deepGreen;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 28px;
            margin: 20px auto 0;
        }
    }
}

@keyframes identifier {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

::v-deep .van-overlay {
    z-index: 99 !important;
}

.confirm-cover-popup {
    width: 580px;
    // height: 790px;
    border-radius: $commonRadius;
    background: #ffffff;
    padding: 40px 24px 32px;
    z-index: 100 !important;

    .title {
        color: $commonTitle;
        font-weight: 500;
        margin-bottom: 28px;
        line-height: 40px;
        text-align: center;
    }

    .star-text {
        color: #eb6f56;
        font-weight: 500;
        margin-bottom: 12px;
        line-height: 40px;
        text-align: center;
    }

    .tags-content {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-bottom: 8px;

        .tags-item {
            width: 256px;
            height: 80px;
            border: 2px solid #858585;
            border-radius: $commonRadius;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #858585;
            position: relative;
            margin-bottom: 20px;

            .active-icon {
                width: 36px;
                height: 36px;
                position: absolute;
                right: 12px;
            }
        }

        .tags-item-active {
            color: #fff;
            border-color: $deepGreen;
            background: $deepGreen;
        }
    }

    .text-input {
        height: 194px;
        padding: 24px 20px;
        background: #f7f7f7;
        border-radius: $commonRadius;
        width: 100%;
        resize: none;
        margin-bottom: 28px;
    }

    .commit-button {
        width: 532px;
        height: 92px;
        background: $greenGradient;
        border-radius: $commonRadius;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        font-weight: 500;
        font-size: $bigSize;
    }
}

/*通用样式*/
.flc {
    display: flex;
    align-items: center;
    justify-content: center;
}

.fls {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.evaluate {
    width: 100%;
    background: #fff;
    border-radius: 12px;
    margin-top: 20px;
    padding: 24px 24px 40px;
    box-sizing: border-box;

    .eveImg {
        display: flex;
        align-items: center;
        margin-top: 22px;

        .eve_img_item {
            width: 144px;
            height: 144px;
            background: #eeeeee;
            border-radius: 8px;
            margin-left: 20px;
            margin-bottom: 20px;
            overflow: hidden;

            &:first-child {
                margin-left: 0;
            }

            img {
                width: 100%;
                height: 100%;
            }
        }
    }

    .addto {
        color: #444444;
        font-weight: 700;
        font-size: 28px;
        margin-bottom: 12px;
        margin-top: 56px;
    }

    .addto_text {
        color: #444444;
        font-size: 28px;
    }

    .evaluate_tips {
        color: #318544;
        font-size: 32px;
        display: flex;
        align-items: center;
        font-weight: 700;

        &::before {
            content: "";
            display: inline-block;
            width: 6px;
            height: 32px;
            background: #318544;
            margin-right: 12px;
        }
    }

    .eva-context-info {
        background: linear-gradient(to right, #f1f1f1 50%, transparent 50%) repeat-x left bottom / 16px 2px;
        padding-bottom: 34px;
        margin-top: 28px;

        // margin-bottom: 28px;
        .tags {
            display: flex;
            align-items: center;
            flex-wrap: wrap;

            // margin-bottom: 20px;
            .tags_item {
                padding: 5px 10px;
                box-sizing: border-box;
                border-radius: 8px;
                border: 2px solid rgba(49, 133, 68, 0.3);
                color: #3d8f50;
                font-size: 24px;
                margin-right: 20px;
                margin-bottom: 20px;
            }
        }

        .title {
            display: flex;
            align-items: center;
            margin-bottom: 16px;
            font-size: 28px;

            & :first-child {
                line-height: 40px;
                margin-right: 24px;
            }

            img {
                width: 32px;
                height: 32px;
                margin-right: 16px;
            }
        }

        .eva-text {
            line-height: 32px;
            font-size: 28px;
            color: #a2a2a2;
        }
    }

    /*建议输入*/
    .advice-text {
        width: 100%;
        height: 248px;
        padding: 24px;
        background: #f7f7f7;
        border-radius: $commonRadius;
        resize: none;
    }

    /*录制按钮*/
    .recording-btn {
        width: 470px;
        height: 80px;
        margin: 24px auto 0;
        background: #649559;
        border-radius: 40px;

        img {
            width: 32px;
            height: 32px;
            margin-right: 12px;
        }

        font-size: $baseSize;
        font-weight: 400;
        color: #ffffff;
        line-height: 80px;
    }

    /*评星*/
    .star-wrap {
        width: 100%;
        margin: 32px 0 36px;

        .star-item {
            margin-bottom: 28px;

            &:last-child {
                margin-bottom: 0;
            }

            .star-item-text {
                font-size: $baseSize;
                font-weight: 400;
                color: $commonText;
                line-height: 40px;
                margin-right: 40px;
            }

            .star {
                width: 32px;
                height: 32px;
                margin-right: 32px;

                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
}

.my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    line-height: 300px;
    text-align: center;
    background-color: #39a9ed;
}

.bottom_btn {
    width: 100%;
    padding: 0 28px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 40px;

    .left_btn {
        width: 312px;
        height: 80px;
        border-radius: 12px;
        border: 2px solid #c77745;
        color: #c77745;
        font-size: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;

        a {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
            opacity: 0;
            z-index: 2;
        }

        &::before {
            content: "";
            display: flex;
            width: 40px;
            height: 40px;
            background: url("~@/assets/images/pagin/icon_hollow.png") no-repeat center/100% 100%;
            margin-right: 4px;
        }
    }

    .right_btn {
        width: 312px;
        height: 80px;
        border-radius: 12px;
        color: #fff;
        font-size: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: $deepGreen;
        margin-left: 20px;

        &::before {
            content: "";
            display: flex;
            width: 40px;
            height: 40px;
            background: url("~@/assets/images/pagin/seccess_icon.png") no-repeat center/100% 100%;
            margin-right: 4px;
        }
    }
}

.point_content {
    width: 100%;
    padding: 0 24px 0;
    box-sizing: border-box;
    margin-top: 28px;

    .point_table {
        padding-top: 32px;
        box-sizing: border-box;
        border-top: 1px dashed #f1f1f1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #444444;
        font-size: 28px;

        .point_table_one {
            width: 398px;
            text-align: center;
        }

        .point_table_two {
            width: 80px;
            text-align: center;
        }

        .point_table_three {
            width: 80px;
            text-align: center;
        }
    }

    .point_table_on {
        margin-top: 16px;
    }

    .point_table_item {
        padding: 24px 0 16px 0;
        box-sizing: border-box;
        width: 100%;
        border-bottom: 1px dashed #f1f1f1;

        .point_table_top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 24px;

            .point_table_one {
                width: 398px;
                display: flex;
                align-items: center;

                &::before {
                    content: "";
                    display: inline-block;
                    width: 36px;
                    height: 36px;
                    background: url("~@/assets/images/pagin/finish_icon.png") no-repeat center/100% 100%;
                    margin-right: 10px;
                }
            }

            .point_table_two {
                width: 80px;
                text-align: center;
            }

            .point_table_three {
                width: 80px;
                text-align: center;
            }
        }

        .point_table_help {
            margin-top: 12px;
            color: #eb6f56;
            font-size: 20px !important;
        }
    }
}

.completed_content {
    width: 100%;
    min-height: 100vh;
    background: #f0f4f1;
    padding: 24px;
    box-sizing: border-box;

    .completed_rabiu {
        width: 100%;
        background: #ffffff;
        border-radius: $commonRadius;

        .completed_titel {
            background: #6c9276;

            .completed_titel_btn {
                color: #6c9276;
            }
        }

        .completed_warp_top {
            width: 100%;
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 24px 0 28px;
            box-sizing: border-box;
            color: #fff;
            font-size: $bigSize;
            border-radius: $commonRadius;
        }

        .completed_titel_right {
            display: flex;
            align-items: center;

            .completed_titel_btn {
                width: 114px;
                height: 44px;
                background: #ffffff;
                border-radius: 22px;
                border: 2px solid rgba(255, 255, 255, 0.3);
                font-size: $smallSize;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .completed_titel_lebel {
                width: 48px;
                height: 48px;
                margin-left: 24px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .wait-title-content {
            background: #e3a751;

            .completed_titel_btn {
                color: #e3a751;
            }
        }

        .confirm-title-content {
            background: $greenGradient;

            .completed_titel_btn {
                color: $deepGreen;
            }
        }

        .completed_warp {
            width: 100%;
            padding: 24px;
            box-sizing: border-box;

            .completed_warp_text {
                color: #2f2f2f;
                font-size: $baseSize;

                .completed_text {
                    margin-top: 16px;
                    text-indent: 2em;
                    text-align: justify;
                }
            }

            .completed_warp_table {
                margin-top: 24px;

                .completed_warp_backone {
                    background: #f7f7f7;
                }

                .completed_warp_table_item {
                    display: flex;
                    align-items: center;
                    padding: 0 24px;
                    width: 100%;
                    height: 60px;
                    box-sizing: border-box;

                    .completed_table_text {
                        width: 37%;
                    }

                    .completed_table_text_right {
                        width: 20%;
                        margin-left: 120px;
                    }

                    .completed_table_num {
                        width: 10%;
                    }

                    .completed_table_icon {
                        width: 6%;
                        display: flex;
                        justify-content: flex-end;

                        &::before {
                            content: "";
                            display: flex;
                            width: 28px;
                            height: 28px;
                            background: url("~@/assets/images/pagin/hege_icon.png") no-repeat center/100% 100%;
                        }
                    }
                }
            }

            .completed_tips {
                display: flex;
                align-items: center;
                margin-top: 22px;

                .completed_tips_left {
                    width: 84px;
                    height: 84px;
                    background: linear-gradient(136deg,
                            #4ea062 0%,
                            #338444 100%);
                    border-radius: 12px;
                    border: 2px solid rgba(255, 255, 255, 0.5);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    font-size: 24px;
                    color: #fff;
                }

                .completed_tips_right {
                    width: 85%;
                    display: flex;
                    // height: 84px;
                    // align-items: center;
                    flex-direction: column;
                    justify-content: center;
                    margin-left: 20px;
                    color: #eb6f56;
                    font-size: 20px;
                }
            }
        }
    }

    .completed_userinfo {
        margin-top: 20px;
        padding: 30px 0;
        box-sizing: border-box;
        border-top: 1px dashed #f1f1f1;
        border-bottom: 1px dashed #f1f1f1;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;

        .userinfo-box {
            margin-bottom: 20px;
            width: 50%;
        }

        .userinfo_left {
            display: flex;

            .header_img {
                width: 90px;
                height: 90px;
                border-radius: 50%;
                overflow: hidden;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .ren_user {
                margin-left: 20px;

                .ren_user_one {
                    font-size: 32px;
                    color: #222222;
                    font-weight: 700;
                    display: flex;
                    align-items: center;

                    span {
                        margin-left: 20px;
                        font-weight: 400;
                        font-size: 25px;
                    }
                }

                .ren_user_two {
                    font-size: 24px;
                    color: #a2a2a2;
                    margin-top: 4px;
                }

                .ren_user_two_on {
                    margin-top: 8px;
                }

                .ren_user_three {
                    font-size: 24px;
                    color: #444444;
                }
            }
        }

        .userinfo_right {
            width: 128px;
            height: 128px;
            border-radius: 50%;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }

    .completed_detail_padding {
        padding: 24px 24px 0;
        box-sizing: border-box;
    }

    .completed_detail_tips {
        width: 100%;
        border-radius: $commonRadius;
        background: #fff;
        margin-top: 24px;

        .completed_detail_title {
            color: $deepGreen;
            font-size: $bigSize;
            display: flex;
            align-items: center;
            font-weight: 700;

            &::before {
                content: "";
                display: flex;
                width: 6px;
                height: 32px;
                background: $deepGreen;
                margin-right: 12px;
            }
        }

        .completed_sm_title {
            font-size: 28px;
            color: #444444;
            display: flex;
            align-items: flex-end;
            margin-top: 18px;
            justify-content: space-between;

            .dateTime {
                color: #a2a2a2;
                font-size: 24px;
            }
        }

        .completed_btn_padding {
            padding-bottom: 24px;
            border-bottom: 1px dashed #f1f1f1;
            box-sizing: border-box;
        }

        .completed_btn_sm_biaoqian {
            padding-top: 22px;
            padding-bottom: 32px;
            box-sizing: border-box;
            width: 100%;
            overflow: auto;
            overflow-y: hidden;
            display: flex;

            &::-webkit-scrollbar {
                width: 0 !important;
                height: 0 !important;
                color: transparent !important;
                display: none;
            }

            .completed_btn_bg {
                display: flex;
            }
        }

        .install_title {
            font-weight: 700;
            font-size: 36px;
            color: #262525;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 30px;
            margin-bottom: 12px;

            &::before {
                content: "";
                display: flex;
                width: 200px;
                height: 2px;
                background: #efefef;
                margin-right: 18px;
            }

            &::after {
                content: "";
                display: flex;
                width: 200px;
                height: 2px;
                background: #efefef;
                margin-left: 18px;
            }
        }

        .swiper_img {
            width: 100%;
            height: 320px;
            position: relative;
            margin-top: 8px;

            .swipe_img_url {
                width: 100%;
                height: 320px;
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;

                .swipe_img_label {
                    width: 140px;
                    height: 56px;
                    background: rgba(0, 0, 0, 0.4);
                    border-radius: 0px 12px 0px 12px;
                    color: #fff;
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 28px;
                }

                .swipe_img_label_green {
                    width: 140px;
                    height: 56px;
                    background: #318544;
                    border-radius: 0px 12px 0px 12px;
                    color: #fff;
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 28px;
                }

                img {
                    width: 100%;
                    // height: 320px;
                }
            }

            .left_swiper {
                position: absolute;
                width: 34px;
                height: 48px;
                top: 0;
                bottom: 0;
                left: 0;
                margin: auto 0;

                img {
                    width: 34px;
                    height: 48px;
                }
            }

            .right_swiper {
                position: absolute;
                top: 0;
                bottom: 0;
                margin: auto 0;
                right: 0;
                width: 34px;
                height: 48px;

                img {
                    width: 34px;
                    height: 48px;
                }
            }
        }

        .swiper_img_list {
            width: 100%;
            margin-top: 8px;
            display: flex;
            // overflow: auto;
            overflow: hidden;

            &::-webkit-scrollbar {
                width: 0 !important;
                height: 0 !important;
                color: transparent !important;
                display: none;
            }

            .swiper_item_warp {
                display: flex;
                // align-items: center;
                // justify-content: space-between;
                transition: all 1s;
                padding: 10px 0;
                box-sizing: border-box;

                .swiper_item_url {
                    flex: 1;
                    width: 168px;
                    height: 128px;
                    margin-right: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .swiper_bg_url {
                        width: 168px;
                        height: 128px;
                        transition: all 1s;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        img {
                            width: 168px;
                            // height: 128px;
                        }
                    }

                    .swiper_sm_url {
                        width: 152px;
                        height: 115px;
                        transition: all 1s;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        img {
                            width: 152px;
                            // height: 115px;
                        }
                    }

                    &:last-child {
                        margin-right: 0;
                    }
                }
            }
        }

        .completed_btn {
            // flex: 1;
            margin-left: 16px;
            padding: 10px 20px;
            white-space: nowrap;
            // width: 300px;
            box-sizing: border-box;
            border-radius: 40px;
            border: 2px solid #84c295;
            display: flex;
            align-items: center;
            justify-content: center;
            color: $deepGreen;
            font-size: $baseSize;
        }

        .completed_btn_sm {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            justify-content: space-between;

            .completed_sm_btn {
                margin-top: 16px;
                padding: 0 10px;
                box-sizing: border-box;
                width: 318px;
                height: 80px;
                border-radius: 12px;
                border: 2px solid #84c295;
                display: flex;
                justify-content: center;
                align-items: center;
                color: $deepGreen;
                font-size: $baseSize;
            }

            .completed_sm_btn_back {
                color: #fff;
                background: $deepGreen;
            }
        }

        .completed_btn_back {
            color: #fff;
            background: $deepGreen;
        }
    }
}

.content-wrap {
    min-height: 100vh;
    background: $commonBgColor;

    /*顶部图片*/
    .top-img {
        width: 100%;
        height: 366px;
    }

    /*card*/
    .card {
        width: 100%;
        margin: 28px auto 0;
        background: #fff;
        border-radius: $commonRadius;
        padding: 24px;

        .title {
            width: calc(100% + 48px);
            margin-left: -24px;
            margin-top: -24px;
            margin-bottom: 32px;
            height: 72px;
            line-height: 72px;
            text-align: center;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            background: #318544;
            border-radius: 12px 12px 0px 0px;
        }

        /*验收文字*/
        .finish-con {
            font-size: $baseSize;
            font-weight: 400;
            color: $commonText;
            line-height: 40px;
            text-indent: 30px;
            padding: 8px 0 28px;
            border-bottom: 2px dashed #f1f1f1;
            letter-spacing: 0;
            word-spacing: 0;
        }

        /*验收按钮*/
        .finish-btn-wrap {
            padding-top: 22px;

            .finish-btn {
                width: 32px;
                height: 32px;
            }

            .finish-btn-text {
                font-size: $baseSize;
                font-weight: 400;
                color: $deepGreen;
                margin-left: 12px;
                white-space: nowrap;
            }
        }

        /*标题*/
        .card-title {
            .card-title-block {
                width: 6px;
                height: 32px;
                background: $deepGreen;
                margin-right: 12px;
            }

            .card-title-text {
                font-size: $bigSize;
                font-weight: 500;
                color: $deepGreen;
                line-height: 44px;
                // white-space: nowrap;
            }
        }

        /*评星*/
        .star-wrap {
            width: 100%;
            margin: 32px 0 36px;

            .star-item {
                margin-bottom: 28px;

                &:last-child {
                    margin-bottom: 0;
                }

                .star-item-text {
                    font-size: $baseSize;
                    font-weight: 400;
                    color: $commonText;
                    line-height: 40px;
                    margin-right: 40px;
                }

                .star {
                    width: 32px;
                    height: 32px;
                    margin-right: 32px;

                    &:last-child {
                        margin-right: 0;
                    }
                }
            }
        }

        /*建议输入*/
        .advice-text {
            width: 100%;
            height: 248px;
            padding: 24px;
            background: #f7f7f7;
            border-radius: $commonRadius;
            resize: none;
        }

        // 查看留言
        .content {
            width: 654px;
            height: 216px;
            border-radius: 8px;
            border: 2px solid #e0e0e0;
            padding: 20px 24px;
            font-size: 28px;
            font-weight: 400;
            color: #858585;
            line-height: 40px;
        }

        /*录制按钮*/
        .recording-btn {
            width: 470px;
            height: 80px;
            margin: 24px auto 16px;
            background: #649559;
            border-radius: 40px;

            img {
                width: 32px;
                height: 32px;
                margin-right: 12px;
            }

            .audio-ref {
                position: absolute;
                z-index: -1;
            }

            font-size: $baseSize;
            font-weight: 400;
            color: #ffffff;
            line-height: 80px;
        }

        // 竣工评价和追加评价
        .addContent {
            margin-top: 48px;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #444444;
            line-height: 40px;

            div:nth-child(1) {
                padding-bottom: 10px;
            }

            div:nth-child(2) {
                padding-bottom: 16px;
            }

            .imgbox {
                display: flex;
                margin-bottom: 40px;

                .img {
                    width: 144px;
                    height: 144px;
                    background: #eeeeee;
                    border-radius: 8px;
                    margin-right: 20px;

                    &:last-child {
                        //margin-right: 0;
                    }

                    object-fit: cover;
                }
            }
        }

        .addContent2 {
            width: 100%;
            margin-top: 60px;

            div:nth-child(1) {
                font-size: 28px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #444444;
                line-height: 40px;
                margin-bottom: 24px;
            }

            .input {
                width: 100% !important;
                padding: 24px;
                background: #f7f7f7;
                border-radius: 12px;
                width: 232px;
                font-size: 28px;
                font-weight: 400;
                color: #858585;
                line-height: 40px;
                margin-bottom: 28px;
            }

            .imgbox {
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
                margin-bottom: 40px;

                .img {
                    width: 144px;
                    height: 144px;
                    background: #eeeeee;
                    border-radius: 8px;
                    margin: 10px;
                    object-fit: cover;
                }

                .img-div {
                    width: 160px;
                    height: 160px;
                    position: relative;
                }
            }

            .addContentBtn {
                width: 186px;
                height: 68px;
                margin: 0 auto;
                // padding: 16px 44px;
                text-align: center;
                line-height: 69px;
                border-radius: 43px;
                border: 2px solid #898989;
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #444444;
                margin-bottom: 74px;
            }
        }
    }

    .sub-card {
        padding-top: 28px;
    }

    /*button*/
    .sub-btn {
        width: 93.6%;
        height: 100px;
        background: $userBgGradient;
        border-radius: $commonRadius;
        margin: 40px auto 94px;

        font-size: $bigSize;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        line-height: 100px;
    }
}

/*通用样式*/
.flc {
    display: flex;
    align-items: center;
    justify-content: center;
}

.fls {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

::-webkit-input-placeholder {
    font-size: 28px;
    color: #858585;
}

.img-box {
    width: 131px;
    height: 131px;
}

.delete-image {
    width: 35px;
    height: 35px;
    position: absolute;
    top: 0;
    right: 0;
}

.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

    video {
        width: 100%;
    }
}

.pop {
    background-color: transparent;
}
</style>